<template>
  <!-- prettier-ignore -->
  <div>
    <p>
      This browser currently contains the Mendelian Randomization and
      sensitivity analyses results for <strong>989</strong> proteins and
      <strong>225</strong> traits, i.e. diseases and risk factors. To start
      using this browser, simply type a protein or trait name into the "search"
      field, for example, ADAM19 or Lung cancer. The full list of proteins can
      be found by following the link on top of the "search" field.
    </p>
    <h3><strong>Publication</strong></h3>
    Jie Zheng,
    Valeriia Haberland,
    Denis Baird,
    Venexia Walker,
    Philip C. Haycock,
    Mark R. Hurle,
    Alex Gutteridge,
    Pau Erola,
    Yi Liu,
    Shan Luo,
    Jamie Robinson,
    Tom G. Richardson,
    James R. Staley,
    Benjamin Elsworth,
    Stephen Burgess,
    Benjamin B. Sun,
    John Danesh,
    Heiko Runz,
    Joseph C. Maranville,
    Hannah M. Martin,
    James Yarmolinsky,
    Charles Laurin,
    Michael V. Holmes,
    Jimmy Z. Liu,
    Karol Estrada,
    Rita Santos,
    Linda McCarthy,
    Dawn Waterworth,
    Matthew R. Nelson,
    George Davey Smith,
    Adam S. Butterworth,
    Gibran Hemani,
    Robert A. Scott,
    Tom R. Gaunt.
    <a href="https://www.nature.com/articles/s41588-020-0682-6">
      Phenome-wide Mendelian randomization mapping the influence of the plasma proteome on complex diseases</a>.
    <i>Nat Genet</i> (2020).
    <a href="https://doi.org/10.1038/s41588-020-0682-6">
      https://doi.org/10.1038/s41588-020-0682-6</a>
    <div class="py-2"></div>
    <h3><strong>Basic overview</strong></h3>
  </div>
</template>

<script>
export default {
  name: "HomeDoc1",
};
</script>
